import { Grid, TextField, Typography } from "@mui/material";
import { CalculatorTextFieldItemProps } from "../types/calculatorTextFieldItemProps";

export const CalculatorTextFieldItem = ({
  text,
  value,
  placeholder,
  endAdornment,
  onChange,
  name,
  error,
  helperText,
}: CalculatorTextFieldItemProps) => (
  <Grid item container alignItems="center" spacing={2}>
    <Grid item xs={6}>
      <Typography>{text}</Typography>
    </Grid>
    <Grid item xs={6}>
      <TextField
        name={name}
        value={value}
        placeholder={placeholder}
        type="number"
        error={error}
        helperText={helperText}
        InputProps={{
          endAdornment,
        }}
        onChange={onChange}
        fullWidth
      />
    </Grid>
  </Grid>
);
